'use client';

import { MdClose, MdOutlineCameraAlt } from 'react-icons/md';
import { ApiRoutes } from '@/settings/routes';
import { Fragment, useEffect, useState } from 'react';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa6';
import { IoMdImages } from 'react-icons/io';
import React from 'react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import ImageWithFallback from '@/components/ImageWithFallback';
import { App_text } from '@/settings/AppText';

const isBrowser = typeof window !== 'undefined';

export default function GallerySingle({ data, images }) {
    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(0);

    // Prepare all images array including thumbnail
    const allImages = [...(data?.thumbnail?.url ? [data.thumbnail] : []), ...images.filter((img) => img?.id !== data?.thumbnail?.id)];

    // Format images for lightbox with titles
    const lightboxImages = allImages.map((image) => ({
        src: image?.url ? ApiRoutes.ASSETS_ENDPOINT + image?.url : '/media/tour-06.jpg',
        alt: image?.alt || 'Gallery image',
        title: image?.alt || 'Gallery image',
        width: 1200,
        height: 800,
    }));

    const openLightbox = (idx = 0) => {
        setIndex(idx);
        setOpen(true);
        // Prevent body scroll when lightbox is open
        if (isBrowser) {
            document.body.style.overflow = 'hidden';
        }
    };

    const closeLightbox = () => {
        setOpen(false);
        // Restore body scroll
        if (isBrowser) {
            document.body.style.overflow = '';
        }
    };

    useEffect(() => {
        if (isBrowser) {
            import('preline/preline').then((module) => {
                // Once loaded, call autoInit after a short delay
                setTimeout(() => {
                    window.HSStaticMethods.autoInit();
                }, 100);
            });
        }

        // Cleanup function
        return () => {
            if (isBrowser) {
                document.body.style.overflow = '';
            }
        };
    }, []);

    console.log(data?.thumbnail?.url);

    return (
        <Fragment>
            <div className="overflow-hidden relative mx-4 rounded-xl gallery">
                <div className="flex flex-col gap-4 md:flex-row">
                    <div className="lg:w-1/2 md:w-1/2">
                        <div className="overflow-hidden relative rounded-lg cursor-pointer group md:h-full" onClick={() => openLightbox(0)}>
                            <div className="w-full h-full aspect-w-16 aspect-h-9 md:aspect-h-12">
                                <ImageWithFallback
                                    src={data?.thumbnail?.url ? ApiRoutes.ASSETS_ENDPOINT + data?.thumbnail?.url : App_text.defaults.images.tour_card}
                                    alt={data?.thumbnail?.alt || 'Gallery thumbnail image'}
                                    className="object-cover"
                                    fill
                                    sizes="(max-width: 768px) 100vw, 50vw"
                                    priority
                                    quality={85}
                                />
                            </div>
                            <div className="absolute inset-0 duration-500 ease-in-out group-hover:bg-slate-900/70"></div>
                            <div className="absolute top-1/2 invisible text-center -translate-y-1/2 start-0 end-0 group-hover:visible">
                                <div className="flex gap-3 justify-center items-center">
                                    {' '}
                                    <span className="flex justify-center items-center p-4 text-white rounded-full transition-all cursor-pointer w-fit bg-main-color hover:bg-opacity-90">
                                        <MdOutlineCameraAlt />
                                    </span>
                                </div>
                            </div>
                            <span
                                className="flex absolute right-4 bottom-4 justify-center items-center p-4 text-white rounded-full transition-all cursor-pointer w-fit bg-main-color hover:bg-opacity-90"
                                title="View all images"
                            >
                                <IoMdImages />
                            </span>
                        </div>
                    </div>
                    <div className="lg:w-1/2 md:w-1/2">
                        <div className="grid grid-cols-2 gap-4">
                            {images
                                .filter((image) => image?.id !== data?.thumbnail?.id)
                                .slice(0, 4)
                                .map((image, idx) => (
                                    <div className="overflow-hidden relative rounded-lg cursor-pointer group lg:h-full" key={idx} onClick={() => openLightbox(idx + 1)}>
                                        <div className="w-full aspect-w-4 aspect-h-3">
                                            {image?.url && image?.url !== null ? (
                                                <ImageWithFallback
                                                    src={ApiRoutes.ASSETS_ENDPOINT + image?.url}
                                                    alt={image?.alt || `Gallery image ${idx + 1}`}
                                                    className="object-cover"
                                                    fill
                                                    sizes="(max-width: 768px) 50vw, 25vw"
                                                    loading="lazy"
                                                    quality={80}
                                                />
                                            ) : (
                                                <ImageWithFallback
                                                    src="/media/H5-img-6.jpg"
                                                    alt={`Default gallery image ${idx + 1}`}
                                                    className="object-cover"
                                                    fill
                                                    sizes="(max-width: 768px) 50vw, 25vw"
                                                    loading="lazy"
                                                    quality={80}
                                                />
                                            )}
                                        </div>
                                        <div className="absolute inset-0 duration-500 ease-in-out group-hover:bg-slate-900/70"></div>
                                        <div className="absolute top-1/2 invisible text-center -translate-y-1/2 start-0 end-0 group-hover:visible">
                                            <div className="flex gap-3 justify-center items-center">
                                                <span className="flex justify-center items-center p-4 text-white rounded-full transition-all cursor-pointer w-fit bg-main-color hover:bg-opacity-90">
                                                    <MdOutlineCameraAlt />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Enhanced Lightbox Gallery */}
            <Lightbox
                open={open}
                close={closeLightbox}
                index={index}
                slides={lightboxImages}
                carousel={{
                    finite: false,
                    preload: 3,
                    padding: '16px',
                    spacing: '30%',
                    imageFit: 'contain',
                }}
                controller={{
                    closeOnBackdropClick: true,
                    closeOnPullDown: true,
                }}
                animation={{
                    swipe: 250,
                    fade: 250,
                }}
                keyboard={{
                    enabled: true,
                }}
                styles={{
                    container: { backgroundColor: 'rgba(0, 0, 0, 75%)' },
                    button: {
                        filter: 'none',
                        color: '#fff',
                        '&:hover': { color: '#fff' },
                        '&:active': { backgroundColor: '#fff' },
                    },
                    slide: {
                        transition: 'all 0.3s ease',
                    },
                    caption: {
                        color: '#fff',
                        fontFamily: 'system-ui',
                        fontSize: '1.1rem',
                        textAlign: 'center',
                    },
                }}
                render={{
                    iconNext: () => <FaAngleRight className="w-7 h-7" aria-label="Next" />,
                    iconPrev: () => <FaAngleLeft className="w-7 h-7" aria-label="Previous" />,
                    iconClose: () => <MdClose className="w-7 h-7" aria-label="Close" />,
                    caption: ({ slide }) => (slide.title ? <div className="px-2 py-2 rounded-md backdrop-blur-sm bg-black/40">{slide.title}</div> : null),
                }}
            />

            {/* Custom CSS for pagination dots */}
            <style jsx global>{`
                .swiper-pagination-bullet {
                    width: 10px;
                    height: 10px;
                    background: rgba(255, 255, 255, 0.5);
                    opacity: 1;
                    margin: 0 5px;
                }
                .swiper-pagination-bullet-active {
                    background: var(--main-color, #fff);
                    transform: scale(1.2);
                }
                .swiper-button-prev svg,
                .swiper-button-next svg {
                    width: unset !important;
                    height: unset !important;
                }
            `}</style>
        </Fragment>
    );
}
